module.exports = __webpack_public_path__ + "img/logo2.e168299c.png";